
import TElogo from "../../../assets/images/dod_logo.png";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import OTPInput from "react-otp-input";

const UserVerificationTE=(props)=>{
    const [email, setEmail] = useState();
    let errorsObj = { email: "", password: "" };
    const [errors, setErrors] = useState(errorsObj);
    const [password, setPassword] = useState();
    const [submitted, setSubmitted] = useState(false);
      const [otp, setOtp] = useState('');
    const navigate = useNavigate();

    const validateFields = () => {
        // OTP validation
        const errorObj = { otp: '' };
        let isError = false;
    
        if (!otp) {
          errorObj.otp = 'OTP is required';
          isError = true;
        } else if (!/^\d{6}$/.test(otp)) {
          errorObj.otp = 'OTP must be a 6-digit number';
          isError = true;
        }
    
        setErrors(errorObj);
        return isError;
    };
    
    
      // Reset the specific error when the user starts typing
      const handleInputChange = (e, field) => {
        if (field === "email") {
          setEmail(e.target.value);
          if (submitted && errors.email) {
            setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
          }
        } else if (field === "password") {
          setPassword(e.target.value);
          if (submitted && errors.password) {
            setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
          }
        }
      };

      function onLogin(e) {
        e.preventDefault();
        setSubmitted(true);
        // Validate fields
        if (validateFields()) {
          return;
        }
        // dispatch(loadingToggleAction(true));
        // dispatch(loginAction(email, password, navigate));
    
        // const res = login(email, password, navigate);
        // console.log("response from login component");
        // if (res) {
        // 	navigate('/dashboard');
        // 	dispatch(loginConfirmedAction(res));
    
        // } else {
        // 	console.log("Login not successfully done");
        // }
      }

    return(<>
     <div className="container-xl">
         <div className="user-login-video-section">
        
            <div className="overlay-section"></div>
         </div>

         <div className="main-content-box row">
            <div className="col-md-6 d-flex flex-column align-items-center align-items-lg-start user-login-left-section">
              <img className="user-login-logo" src={TElogo} alt="logo"/>
              <h1 className="text-white fw-bold">Authenticate Your Account</h1>
              <p className="text-white">Please confirm your account by entering the authorization code
              send to <b>admin@gmail.com</b> it will expire in <b>6 minutes</b>.</p>
              <hr className="bottom-line"/>
            </div>

            <div className="col-md-6 user-login-right-section">
               <div className="user-login-section">
                <form onSubmit={onLogin}>
                <div className="mb-3">
                        <label className="mb-1 text-dark">
                          {/* <strong>OTP</strong> */}
                        </label>
                        <OTPInput
                          containerStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            maxWidth: '360px',
                            margin: '0 auto',
                          }}
                          inputStyle="otp-input-style"
                          inputType="number"
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          renderSeparator={<span className="text-white">-</span>}
                          renderInput={(props) => <input {...props} />}
                        />
                        {errors.otp && (
                          <div className="text-danger fs-12 mt-2">
                            {errors.otp}
                          </div>
                        )}
                      </div>
                
                      <div className="d-flex gap-3 mt-4">
                        <button type="submit" className="btn btn-light text-dark btn-block">
                          Log Out
                        </button>

                        <button type="submit" className="btn text-white btn-block handle-login-btn">
                           Verify
                        </button>

                       {/* <button
                         type="submit"
                         className="btn text-white mt-3 px-3"
                         onClick={()=>navigate('/user/login')}>
                          <FaArrowLeft/> Go back
                       </button> */}
                      </div>
                    </form>
               </div>
            </div>
         </div>
     </div>
    </>)
};

export default UserVerificationTE;